import DynamicModuleList from 'src/pages/Setup/DynamicModule';

export const dynamicRoutes = [
  { path: '/setup/:module/list', component: DynamicModuleList },
];
